import Icon from './Icon';
import { ICON_TYPES } from './Icon';

export default Icon;
export { ICON_TYPES };
